import {useEffect, useState} from "react";
import MainPage from "./pages/MainPage/MainPage";
import ModalForm from "./components/ModalForm/ModalForm";
import LoginDialog from "./components/LoginDialog/LoginDialog";
import "./App.css"
import globalCalls from "./modules/GlobalCalls";
import ServerManager from "./API/ServerManager";
import LoadingOverlay from "./components/LoadingOverlay/LoadingOverlay";
import {getCurrentWorkDayStamp, getLastLoginWorkDayStamp} from "./utils/LoginUtil";
import {user} from "./modules/User";
import ArtistSuggestionsStatusService from "./API/ArtistSuggestionsStatusService";

function App() {
    const [isChecked, setIsChecked] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    globalCalls.logout = () => setIsLoggedIn(false);

    useEffect(() => {
        async function check(){
            try {
                //await new Promise(resolve => setTimeout(resolve, 2000));
                const response = await ServerManager.checkAuth();

                if (getCurrentWorkDayStamp() === getLastLoginWorkDayStamp()) {
                    user.id = response.id;
                    user.email = response.email;
                    user.name = response.name;
                    user.addedEventCount = response.addedEventCount;
                    setIsLoggedIn(true);

                    ArtistSuggestionsStatusService.forceUpdate();
                }
            }
            catch (error) {
                // still isLoggedIn=false
            }

            setIsChecked(true);
        }

        check();
    }, []);

    useEffect(() => {
        ArtistSuggestionsStatusService.start();

        return () => {
            ArtistSuggestionsStatusService.stop();
        }
    }, []);

    return (
        <div className="app">
            {!isChecked && <LoadingOverlay open={true} title="Загрузка"/>}
            {isChecked && <>
                <ModalForm visible={!isLoggedIn} noCloseButton>
                    <LoginDialog setIsLoggedIn={setIsLoggedIn}/>
                </ModalForm>
                <MainPage/>
            </>}
        </div>
    );
}

export default App;